import { motion } from "framer-motion";
import { Car, Flame, ChefHat, Trees, Sofa, Wifi } from "lucide-react";
import { Reveal, MaskLinesInView } from "./motion";

const ITEMS = [
  { icon: ChefHat, title: "Cozinha Totalmente Equipada", desc: "Cozinha ampla, pronta para receber grupos grandes e longas refeições em família." },
  { icon: Sofa, title: "Salas Amplas com Lareira", desc: "Espaços comuns com lareira, chandelier e vistas para o jardim — perfeitos para serões demorados." },
  { icon: Flame, title: "Aquecimento Central", desc: "Aquecimento em toda a casa, para invernos aconchegantes sem preocupações." },
  { icon: Trees, title: "Terreno Privado & Floresta", desc: "Hectares de terreno privado com árvores altas — a sensação de estar no meio da floresta." },
  { icon: Car, title: "Estacionamento Privado", desc: "Estacionamento gratuito para vários carros dentro da propriedade." },
  { icon: Wifi, title: "Wi-Fi de Alta Velocidade", desc: "Ligação estável em toda a casa, para quem precisa de estar conectado ou trabalhar remotamente." },
];

const EASE = [0.22, 1, 0.36, 1];

export default function Amenities() {
  return (
    <section id="comodidades" data-testid="amenities-section" className="relative py-28 lg:py-40 bg-[#EFEBE0]">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-14 bg-forest/40" />
              <p className="overline">Comodidades</p>
            </div>
          </Reveal>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[4rem] leading-[1.05] tracking-tight text-forest font-light">
            <MaskLinesInView lines={["Tudo o que precisam,", <span key="i" className="italic">e mais um pouco.</span>]} />
          </h2>
        </div>

        <div className="mt-16 lg:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-border/70 border border-border/70">
          {ITEMS.map(({ icon: Icon, title, desc }, i) => (
            <motion.div
              key={title}
              data-testid={`amenity-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-8%" }}
              transition={{ duration: 0.7, ease: EASE, delay: (i % 3) * 0.08 }}
              className="group bg-cream p-8 lg:p-10 flex flex-col gap-6 min-h-[240px] hover:bg-white transition-colors"
            >
              <div className="flex items-center justify-between">
                <Icon size={40} strokeWidth={1.25} className="text-forest group-hover:text-terracotta group-hover:scale-110 transition-all duration-300" />
                <span className="font-display text-forest/25 text-3xl">0{i + 1}</span>
              </div>
              <div>
                <h3 className="font-display text-2xl lg:text-3xl text-forest leading-tight">{title}</h3>
                <p className="mt-3 text-muted-foreground text-[0.95rem] leading-relaxed">{desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
